export const transition = { type: "spring", duration: 0.5 }; // Reduced duration

export const fadeAnimation = {
  initial: { opacity: 0, transition: { ...transition, delay: 0.3 } },
  animate: { opacity: 1, transition: { ...transition, delay: 0 } },
  exit: { opacity: 0, transition: { ...transition, delay: 0 } },
};

export const headTextAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { type: "spring", duration: 0.3 }, // Simplified
};

export const headContentAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { type: "spring", duration: 0.4, delay: 0.2 }, // Simplified
};

export const headContainerAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { type: "spring", duration: 0.5 }, // Simplified
};